export default "__VITE_ASSET__DgtMBbJr__"